jQuery.noConflict();
jQuery(document).ready(function($) {
  $('#soff_shipping_method').change(function(){
    $('#submit_shipping_method').click();
  });
});
